import type { RouteObject } from "react-router-dom";
import { lazy } from "react";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Countdown from "../pages/countdown/page";
import Countdown2Min from "../pages/countdown-2min/page";
import PersonalBrand from "../pages/personal-brand/page";
import RoboticsRegister from "../pages/robotics-register/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/countdown",
    element: <Countdown />,
  },
  {
    path: "/countdown-2min",
    element: <Countdown2Min />,
  },
  {
    path: "/personal-brand",
    element: <PersonalBrand />,
  },
  {
    path: "/register-personal-brand",
    element: lazy(() => import("../pages/register-personal-brand/page")),
  },
  {
    path: "/robotics-register",
    element: <RoboticsRegister />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
